/** @jsxImportSource @emotion/react */

import React from "react";

export function PopularityRateAnalysis() {
  return null;
}
